import axios from "axios";
import { LotProcessStep } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise(
		"ald_compound_process_steps",
		async () => (await axios.get<LotProcessStep[]>(`/api/compounds/process/steps`)).data,
	);
